<template>
  <div class="subscribe-wrap">
    <!-- <van-nav-bar :title="title"> </van-nav-bar> -->
    <div class="outBox">
      <div class="bjImg">
        <div class="title">{{ title }}</div>
        <div class="welcome">欢迎您</div>
      </div>
    </div>

    <div class="form-wrap">
      <van-field name="uploader"  required class="uploader" size="large" center>
        <template #label>
          <div class="flex flex-vc">
            <div class="mg-r">识别头像</div>
            <div class="mg-r">
              <van-popover v-model="showPopover" trigger="click">
                <div class="flex flex-vc flex-a headIconts">
                  <div class="flex-1">
                    <img src="@/assets/person.png" alt="" style="width: 3.5rem; height: 4.2rem" />
                  </div>
                  <div class="flex-1 zt">
                    要求近三月正面免冠照五官清晰，无过度美颜
                  </div>
                </div>
                <template #reference>
                  <van-icon name="question-o" size="10px" />
                </template>
              </van-popover>
            </div>
            <div class="desc ml-1">近期免冠头像无过度美颜</div>
          </div>
        </template>
        <template #input>
          <img 
            :src="personList[0].photoImg" 
            v-if="personList[0].photoImg" alt="" 
            style="
              width: 2.75rem;
              height: 2.75rem;
              border-radius: 50%;
              object-fit: cover;
            " 
            @click="previewImg(personList[0].photoImg)" />


          <van-uploader :deletable="false" v-if="!personList[0].photoImg" v-model="curFileList" :after-read="afterReadCur"
            :max-count="1">
            <img src="@/assets/images/avatar.png" alt="" style="width: 2.75rem; height: 2.75rem;border-radius: 50%;
              object-fit: cover;" />
          </van-uploader>
          <van-uploader :after-read="afterReadCur" :max-count="1" v-if="personList[0].photoImg"
            style="position: relative;">
            <van-tag plain type="primary"
              style="margin-left: 0.5rem;position: absolute;top: 50%;transform: translateY(-50%);">更换</van-tag>
          </van-uploader>
        </template>
      </van-field>
      <van-field required v-model="personList[0].visitorName" label="姓名" placeholder="请输入姓名" size="large" />
      <van-field required v-model="personList[0].visitorPhone" label="手机号" placeholder="请输入手机号码" size="large" maxlength="11" />
      <van-field required v-model="singleQuery.acceptName" label="被访人" placeholder="请选择被访人" size="large" clickable readonly
        @click="$refs.interviewee.showiIntervieweePopup = true" />
      <van-field required v-model="singleQuery.visitorBeginTime" label="拜访时间" placeholder="点击选择" clickable readonly is-link
        @click="clickTime('starttime')" size="large" />
      <van-field required v-model="singleQuery.visitorEndTime" label="离开时间" placeholder="点击选择" clickable readonly is-link
        @click="singleQuery.visitorBeginTime && clickTime('endtime')" size="large" />
      <van-field v-model="personList[0].visitorIdCrde" :required="senseIDStatus" label="身份证号码" placeholder="请输入身证号码"
        size="large" />
      <van-field v-model="singleQuery.affiliatedUnit" label="所属单位" placeholder="请输入所属单位" size="large" />
      <van-field v-model="singleQuery.carNumber" label="车牌号" placeholder="请输入您的车牌号" size="large">
        <template #label>
          <div class="flex relative">
            <div>
              <span>车牌号</span><span style="font-size: 10px; color: #c4c4c4">（选填）</span>
            </div>
            <!-- <div @click="showCpPopup" style="font-size:12px;" class="flex flex-vc absolute r0">
              <div style="color:#666666;margin-right:3px;">{{carSx}}</div>
              <div><van-icon name="arrow-down" size="0.9rem" color="#666666" /></div>
            </div> -->
          </div>
        </template>
      </van-field>
      <van-field name="radio" label="预约事由" size="large">
        <template #input>
          <!-- <van-radio-group
            v-model="singleQuery.visitorGoal"
            direction="horizontal"
            @change="changeRadioType">
            <van-radio
              :name="item.dictLabel"
              v-for="item in work"
              style="margin-bottom: 0.5rem;"
              :key="item.dictLabel"
              >{{ item.dictLabel }}</van-radio
            >
          </van-radio-group> -->
          <div class="syList flex flex-r">
            <div class="syTag" v-for="item in work" @click="selectType(item.dictLabel)"
              :class="singleQuery.visitorGoal === item.dictLabel ? 'ed' : ''" :key="item.dictLabel">
              {{ item.dictLabel }}
            </div>
          </div>
        </template>
      </van-field>
      <div>
        <van-field type="textarea" placeholder="请输入备注" label="备注" v-model="singleQuery.remark" size="large"></van-field>
      </div>
    </div>
    <!-- 添加同行人员 -->
    <div>
      <div class="add-person-wrap" @click="showPersonPopup = true" v-if="personList.length <= 1">
        <span class="iconfont">&#xe69f;</span>
        <span>添加同行人员</span>
      </div>
      <!-- 添加后的人员列表 -->
      <div class="person-list" v-if="personList.length > 1">
        <div class="person-header">
          <span>同行人员</span>
          <div @click="showPersonPopup = true">
            <span class="iconfont">&#xe69f;</span> <span>添加同行人员</span>
          </div>
        </div>
        <div class="person-item flex flex-vc" v-for="(item, index) in personList.slice(1)" :key="index">
          <div class="person-avatar">
            <img :src="item.photoImg" />
          </div>
          <div class="person-info flex-1">
            <div class="person-name">{{ item.visitorName }}</div>
            <div class="person-phone">{{ item.visitorPhone }}</div>
          </div>
          <div class="handle" @click="clickPersonMinus(index)">删除</div>
        </div>
      </div>
    </div>
    <!-- 健康吗以及行程码 -->
    <div class="test_prove" v-if="nucleStatus">
      <div class="test_prove_item">
        <div class="label_item">
          <span class="test_prove_item_label" @click="() => {
            isHealthcode = !isHealthcode;
            healthcodeImage = [];
          }
            ">预约人及同行人健康码</span>
          <van-checkbox style="display: inline-block" v-model="isHealthcode"></van-checkbox>
        </div>
        <div class="img_item" v-if="isHealthcode">
          <div class="image_list" v-for="(item, index) in healthcodeImage" :key="index">
            <van-icon name="cross" class="image_list_icon" @click="delImage('healthcodeImage', index)" />
            <img :src="item.imgUrl" alt="" @click="previewImg(item.imgUrl)" />
          </div>
          <!-- 添加图片按钮 -->
          <div class="add_img" @click="avatarUpload3">
            <van-icon name="plus" />
            <span>添加图片</span>
          </div>
        </div>
      </div>
      <div class="test_prove_item">
        <div class="label_item">
          <span class="test_prove_item_label" @click="() => {
            isTripCode = !isTripCode;
            tripCodeImage = [];
          }
            ">预约人及同行人行程码</span>
          <van-checkbox style="display: inline-block" v-model="isTripCode"></van-checkbox>
        </div>
        <div class="img_item" v-if="isTripCode">
          <!-- 图片列表 -->
          <div class="image_list" v-for="(item, index) in tripCodeImage" :key="index">
            <van-icon name="cross" class="image_list_icon" @click="delImage('tripCodeImage', index)" />
            <img :src="item.imgUrl" alt="" @click="previewImg(item.imgUrl)" />
          </div>

          <!-- 添加图片按钮 -->
          <div class="add_img" @click="avatarUpload4">
            <van-icon name="plus" />
            <span>添加图片</span>
          </div>
        </div>
      </div>
      <div class="test_prove_item">
        <!-- label文字描述 -->
        <div class="label_item">
          <span class="test_prove_item_label" @click="() => {
            isTestProve = !isTestProve;
            testProveImage = [];
          }
            ">预约人及同行人核酸检测证明</span>
          <van-checkbox style="display: inline-block" v-model="isTestProve"></van-checkbox>
        </div>
        <!-- 添加图片部分 -->
        <div class="img_item" v-if="isTestProve">
          <div class="image_list" v-for="(item, index) in testProveImage" :key="index">
            <van-icon name="cross" class="image_list_icon" @click="delImage('testProveImage', index)" />
            <img :src="item.imgUrl" alt="" @click="previewImg(item.imgUrl)" />
          </div>
          <!-- 添加图片按钮 -->
          <div class="add_img" @click="avatarUpload5">
            <van-icon name="plus" />
            <span>添加图片</span>
          </div>
        </div>
      </div>
      <!-- 提示  -->
      <div style="color: #959596; font-size: 0.75rem; padding-bottom: 0.75rem">
        以上信息如实填写 , 如有隐瞒承担一切后果 , 特此承诺!
      </div>
    </div>

    <div style="padding: 2rem 1rem">
      <van-row :gutter="20">
        <!-- <van-col :span="12">
          <van-button round type="warning" block @click="clickSave"
            >暂存</van-button
          >
        </van-col> -->
        <van-col :span="24" style="display: flex;justify-content: center;font-size: 0.65rem;align-items: center;margin-bottom: 0.8rem;line-height: 1;">
          <div style="margin-right: 0.5rem;" @click="showXieyi = true">
            <img v-if="checked" src="./check.png" style="height: 0.65rem;" />
            <img v-else src="./uncheck.png" style="height: 0.65rem;" />
          </div>
          <div @click="showXieyi = true">
            我同意<span style="color: #3497FD;">《人脸采集告知书》</span>及允许人脸信息通过互联网传输
            
          </div>
        </van-col>
        <van-col :span="24">
          <van-button round type="info" block @click="clickSubmit" :disabled="subDisabled || !checked" :loading-text="subTextBtn"
            :loading="subDisabled">确认预约</van-button>
        </van-col>
      </van-row>
    </div>

    <!-- 拜访开始时间 -->
    <SelectTime ref="starttime" :typeTime="'选择拜访时间'" @time="handleTimeStartConfirm" :minDate="startMinTime"
      />

    <!-- 拜访离开时间 -->
    <SelectTime ref="endtime" :typeTime="'选择离开时间'" @time="handleTimeEndConfirm" :minDate="endMinDate"
      :maxDate="endMaxTime" :currentDate="endCurTime" />
    <!-- 车牌号省份缩写简称 -->
    <van-popup v-model="showCSx" position="bottom" custom-style="height: 50%;" bind:close="onClose">
      <van-area title="" @confirm="cpConfirm" @cancel="cpCancel" ref="areacs" value="1" :area-list="carProvince"
        :columns-num="1" />
    </van-popup>
    <!-- 添加人员弹窗 -->
    <van-popup  v-model="showPersonPopup" round position="bottom" :style="{ height: '400px' }">
      <div class="add-person">
        <div class="add-person-title">添加同行人员</div>
        <van-field name="uploader" required label="识别头像" size="large" center>
          <template #input>


            <!-- <img src="@/assets/images/avatar.png" alt="" style="
                width: 2.75rem;
                height: 2.75rem;
                object-fit: cover;
                border-radius: 50%;
              " v-if="!paramsList.photoImg" @click="avatarUpload2" /> -->

            <img :src="paramsList.photoImg" alt="" style="
                width: 2.75rem;
                height: 2.75rem;
                object-fit: cover;
                border-radius: 50%;
              " v-if="paramsList.photoImg" 
              @click="previewImg(paramsList.photoImg)" 
            />
            <!-- 图片上传 -->
            <van-uploader :deletable="false" v-if="!paramsList.photoImg" :after-read="avatarUpload2" :max-count="1">
              <img src="@/assets/images/avatar.png" alt="" style="width: 2.75rem; height: 2.75rem;border-radius: 50%;
              object-fit: cover;" />
            </van-uploader>


            <van-uploader :after-read="avatarUpload2" :max-count="1" v-if="paramsList.photoImg"
              style="position: relative;">
              <van-tag plain type="primary"
                style="margin-left: 0.5rem;position: absolute;top: 50%;transform: translateY(-50%);">更换</van-tag>
            </van-uploader>

          </template>
        </van-field>
        <van-field v-model="paramsList.visitorName" label="姓名" placeholder="请输入姓名" size="large" required />
        <van-field v-model="paramsList.visitorPhone" label="手机号" placeholder="请输入手机号" size="large" maxlength="11"
          required />
        <van-field v-model="paramsList.visitorIdCrde" label="身份证号" placeholder="请输入身份证号" size="large"
          :required="senseIDStatus" />
        <van-row class="add-btn-group" gutter="20">
          <van-col span="12" style="text-align: right">
            <van-button type="default" block @click="showPersonPopup = false">
              取消</van-button>
          </van-col>
          <van-col span="12">
            <van-button type="info" block @click="handleAddPerson">确认</van-button>
          </van-col>
        </van-row>
      </div>
    </van-popup>
    <!-- 添加被访人 -->
    <Interviewee ref="interviewee" @selectItem="handleSelIntervieweeItem" pageType="fk" />

    <!-- 添加微信公众号跳转弹窗 -->
    <van-popup round v-model="showToast">
      <div class="popup_tip">
        <div>
          <h6>温馨提示</h6>
          <div class="tip_con">
            <p class="p_text">请先关注公众号，关注后可接收拜访审批通知，若已关注，忽略该提示</p>
          </div>
        </div>
        <div class="btns">
          <div class="tip_btn" style="background-color:#959596;" @click="showToast = false">
            忽略
          </div>
          <div class="tip_btn" @click="guanzhu">
            去关注
          </div>
        </div>

      </div>

    </van-popup>

    <!-- 分享二维码 /> -->
    <shareQRcode ref="shareQRcode" :url="qrcodeUrl" />


    <van-popup v-model="showXieyi" :style="{ padding: '1rem', width: '90%' }" round>
      <div class="xieyi-top">人脸采集告知书</div>
      <div class="xieyi-content">
        <p class="slot_p">本告知书依据《人脸识别技术应用安全管理办法》（2025年6月1日施行）制定，相关内容随法规调整更新，最新版本以平台公示为准。</p>
      	<h5>一、采集主体信息</h5>
      		<h6>（一）校方（信息采集方）</h6>
      		<p class="slot_p">学校名称：{{schoolName}}</p>
      		<p class="slot_p">联系方式：{{schoolInfoMini.counterpartPhone}}</p>
      		<h6>（二）技术处理方</h6>
      		<p class="slot_p">公司名称：济南亚爱特软件有限公司</p>
      		<p class="slot_p">统一社会信用代码：913701007306532069</p>
      		<p class="slot_p">联系方式：0531-87901000</p>
      		<p class="slot_p">地址：山东省济南市高新区齐鲁软件园大厦二层</p>
      	<h5>二、处理目的、必要性与方式</h5>
      		<p class="slot_p">基于校园公共安全管理需求，根据校方管理需要，人脸信息可能会用于以下场景，并遵循“最小必要”原则，定时删除存储的视频和个人信息。</p>
      
      		<h6>（一）门禁与考勤管理</h6>
      		<p class="slot_p">
      			用于身份核验（进出宿舍、校门口）、考勤记录（校门口、宿舍），替代传统手工登记，防止非授权人员进入，实时掌握师生出勤状态。采集人脸照片，不存储与身份验证无关的信息。</p>
      		<h6>（二）门禁与考勤管理</h6>
      		<p class="slot_p">
      			用于识别敏感人员、陌生人入侵、危险区域闯入、异常行为等。基于国务院《公共安全视频图像信息系统管理条例》第九条，对可能危害校园安全的行为进行事前预警。仅在预警触发时临时存储预警视频。
      		</p>
      		<h6>（三）访客管理</h6>
      		<p class="slot_p">用于访客身份核验（刷脸通行）、预约审批记录关联，替代手写登记，避免纸质信息存储和泄露隐私信息。仅采集访客预约时主动提交的人脸信息。</p>
      		<h6>（四）宿舍无感考勤</h6>
      		<p class="slot_p">
      			用于自动统计学生归寝情况，预警“未归”“晚归”等异常状态，及时发现学生安全隐患（如深夜未归），符合《中华人民共和国未成年人保护法》对住宿生管理要求。仅记录进出时间与人脸特征匹配结果。
      		</p>
      		<h6>（五）人员轨迹查询</h6>
      		<p class="slot_p">
      			用于师生失联、校园欺凌事件等极端场景下，协助查找活动轨迹（使用时需身份验证并留存操作记录）。符合《中国人民共和国未成年人保护法》第40条“紧急保护”要求，仅限在履行安全职责时使用。
      		</p>
      	<h5>三、个人信息类型与范围</h5>
      		<p class="slot_p">
      			采集内容：人脸照片、姓名、学号/工号（仅用于绑定身份信息）。
      		</p>
      	<h5>四、保存期限与存储</h5>
      		<h6>（一）保存期限：</h6>
      
      		<p class="slot_p">
      			采集到的人脸信息最长保留至学生毕业（教职工离职）后30天，到期自动删除。人脸抓拍照片90天删除，识别记录1年删除。
      		</p>
      		<h6>（二）数据传输：</h6>
      		<p class="slot_p">
      			人脸等敏感数据加密传输，基于校方机房条件及安全管理需要，可能会通过互联网传输至国内服务器。教职工本人（或监护人已获得被监护人）单独同意，允许通过互联网传输人脸信息。
      		</p>
      		<h6>（三）存储：</h6>
      		<p class="slot_p">
      			数据加密存储于学校本地服务器，或中国境内服务器。
      		</p>
      	<h5>五、安全保护措施</h5>
      		<p class="slot_p">
      			1. 采用国密算法加密传输与存储，设置严格访问权限（仅限校方管理人员操作）。
      		</p>
      		<p class="slot_p">
      			2. 每季度开展安全风险评估，确保防护措施与风险等级匹配（依据《人脸识别技术应用安全管理办法》第2条个人信息保护影响评估要求）。
      		</p>
      	<h5>六、您的权利</h5>
      		<p class="slot_p">
      			1. 查询/更正/删除：登录人脸采集小程序操作，或致电校方申请。
      		</p>
      		<p class="slot_p">
      			2. 撤回同意：撤回人脸同意授权后可通过身份证验证、人工登记等替代方式（《人脸识别技术应用安全管理办法》第十条）。
      		</p>
      		<p class="slot_p">
      			3. 投诉举报：对处理有异议可向网信办或公安部门反映。
      		</p>
      	<h5>七、风险提示</h5>
      		<p class="slot_p">
      			人脸信息泄露可能导致身份冒用风险（如非法进入校园），我们将通过技术与管理措施最大限度降低风险，但无法承诺绝对安全。
      		</p>
      	<h5>八、非唯一验证方式</h5>
      		<p class="slot_p">
      			不同意人脸验证的用户，可选择以下方式：
      		</p>
      		<p class="slot_p">
      			1、学生/教职工：刷校园卡+人工核验，或校方提供的其他方式。
      		</p>
      		<p class="slot_p">
      			2、访客：人工登记联系方式，或校方提供的其他方式。
      		</p>
      	
      	<h5>九、未成年人保护</h5>
      		<p class="slot_p">
      			采集和提交未满14周岁学生信息前，需取得监护人同意。
      		</p>
      	<h5>十、自愿同意声明</h5>
      		<p class="slot_p">
      			我已完整阅读并理解上述内容，自愿授权本校及济南亚爱特软件有限公司按照本告知书处理本人/被监护人的人脸信息。
      		</p>
      	<h5>十一、咨询与投诉</h5>
      		<p class="slot_p">
      			客服电话：0531-87901000
      		</p>
      </div>
      <div class="xieyi-bottom">
        <van-button type="default" @click="handleDisagree()" round style="width: 40%;">不同意</van-button>
        <van-button type="info" @click="(showXieyi = false), (checked = true)" round style="width: 40%;">同 意</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import moment from "moment";
import { compare, getDateYMD, timeFormart } from "@/utils";
import * as validate from "@/utils/validate";
import { upload } from "@/utils/upload";
import Interviewee from "@/components/subScribePopup/interviewee";
import SelectTime from "@/components/subScribePopup/selectTime";
import subSuccess from "@/components/subScribePopup/subsuccess";
import shareQRcode from "@/components/subScribePopup/qrcodePopup";
// import { init } from '../utils/wxSDK'
// import assign from "@/mixins/assign";
import wxSDK from "@/utils/wxSDK.service";
import uploadImg2 from "@/utils/upload.service3";
import uploadImg from "@/utils/upload.service";
import { ImagePreview } from "vant";
//省份简称
import { carProvince } from "@/utils/province";
const paramsList = {
  visitorName: "",
  visitorPhone: "",
  visitorIdCrde: "",
  photoImg: "",
};
export default {
  // mixins: [assign],
  components: {
    Interviewee,
    SelectTime,
    subSuccess,
    shareQRcode,
  },

  computed: {
    startMinTime() {
      return new Date(moment(new Date()).subtract("10", "minute"));
    },
    endCurTime() {
      return new Date(moment(this.endMinDate).add(1, "h"));
    },
    endMaxTime() {
      return new Date(moment(this.endMinDate).add(this.maxDuration, "hours"));
    },
    title() {
      return Object.keys(this.$store.state.inviteSubData).length > 0
        ? this.$store.state.inviteSubData.schoolName
        : JSON.parse(localStorage.getItem("userInfo")).schoolName;
    },
  },
  data() {
    return {
      showPopover: false,
      showXieyi: false,
      checked: false,

      carNumber: "",
      carSx: "京",
      showCSx: false,
      carProvince: carProvince,
      showPersonPopup: false,
      personList: [
        {
          visitorName: '',
          visitorPhone: "",
          visitorIdCrde: "",
          photoImg: "",
        },
      ],
      paramsList: Object.assign(paramsList),
      maxDuration: 48,
      endMinDate: "",
      singleQuery: {
        // visitorType: '',
        remark: "",
        visitorGoal: "",
        type: 0, // 0手动预约 1主动邀约邀约
        // startTime0:'',
        visitorBeginTime: "",
        visitorEndTime: "",
        carNumber: "",
        affiliatedUnit: "",
        // initiatorId: '', // 发起者id
        acceptName: "",
        acceptId: "", // 接受者id
        // personnelMessageString:'0',// 0手动预约 1主动邀约邀约
      },
      addPersonFileList: [],
      curFileList: [],
      curType: "",
      // radioType: '',
      work: [],
      subDisabled: false,
      subTextBtn: "确认预约",
      senseIDStatus: null,
      nucleStatus: null, //核酸板块显示
      qrcodeUrl: null,
      // 是否选中预约人和同行人健康码
      isHealthcode: false,
      healthcodeImage: [],
      // 是否选中预约人和同行人行程码
      isTripCode: false,
      tripCodeImage: [],
      // 是否选中核酸检测证明
      isTestProve: false,
      testProveImage: [],
      showToast: false,
      schoolInfoMini: {}

      
    };
  },
  mounted() {
    if (!JSON.parse(localStorage.getItem("userInfo")).schoolId) {
      let zhi = JSON.parse(localStorage.getItem("userInfo"));
      zhi.schoolId = this.$route.query.schoolId;
      // console.log(JSON.stringify(zhi));
      // console.log(JSON.stringify(JSON.parse(localStorage.getItem('userInfo'))));
      localStorage.setItem("userInfo", JSON.stringify(zhi));
    }
    // wxSDK.jsSDKConfig().then((res) => {
    //   wxSDK.share({
    //     title: `邀请您预约123`,
    //     description: '来一起预约123',
    //     imgUrl:
    //       'https://img2.woyaogexing.com/2020/08/05/1730990ea10a48c0b4583e1a5bb4b383!400x400.jpeg',
    //     url: `https://ai-prod.asiait.net/subscribe`,
    //   })
    // })
    this.getWork();
    this.getSchoolInfoMini()

    // this.getMaxDur()
    this.getSysSchool();
    // this.getWXConfig()
    if (localStorage.getItem("__sub__") && this.$route.query.type !== "again") {
      let { photoImg, visitorName, visitorPhone, visitorIdCrde, ...rest } =
        JSON.parse(localStorage.getItem("__sub__"));
      // this.curFileList.push({
      //   url: photoImg,
      // });

      this.personList[0].visitorName = visitorName;
      this.personList[0].visitorPhone = visitorPhone;
      this.personList[0].visitorIdCrde = visitorIdCrde;
      // this.personList[0].photoImg = photoImg;
      this.singleQuery = rest;
      this.singleQuery.visitorBeginTime = "";
      this.singleQuery.visitorEndTime = "";
    } else {
      let data = JSON.parse(localStorage.getItem("userInfo"));
      if (data) {
        this.personList[0].visitorName = data.personType  != 2 ?  (data.name || "") : ''
        this.personList[0].visitorPhone = data.mobile || "";
        this.personList[0].visitorIdCrde = data.idNumber || "";
        // this.personList[0].photoImg = data.avatar || "";

        this.singleQuery.carNumber = data.licensePlate;
        this.singleQuery.affiliatedUnit = data.guestCompany;
      }
    }
    if (this.$route.query.type == "again") {
      this.getSubDetail(this.$route.query.id);
    }

    // this.singleQuery.carNumber = carNumber || ''
    // this.singleQuery.affiliatedUnit = affiliatedUnit || ''
  },
  created () {
    this.getSchoolInfo();
    // 获取用户是否关注当前公众号
    this.geTattention()
  },
  methods: {
    handleDisagree() {
      this.showXieyi = false;
      this.checked = false;

      // // 判断是否在微信环境中
      // if (typeof WeixinJSBridge !== 'undefined') {
      //   // 微信环境下关闭窗口
      //   WeixinJSBridge.call('closeWindow');
      // } else {
      //   // 非微信环境下的处理，可以提示用户手动关闭
      // }
    },
    async geTattention () {
      const {code,data} = await this.$https.getIsSubscribe({
        appId: localStorage.getItem("appId"),
        openId: JSON.parse(localStorage.getItem("userInfo")).openId
      })  
      if (code == 200 && !data ) {
        this.showToast = true
      }
    },
  // 获取当前学校的名称和联系电话
  async getSchoolInfoMini () {
      const { code, data } = await this.$https.getSchoolInfoMiniById({
        id: this.$route.query.schoolId
      });
      if (code == 200 && data) {
        this.schoolInfoMini = data;
      }
    },
    // 获取学校信息
    async getSchoolInfo() {
      const { code, data } = await this.$https.getSchoolInfo({
        id: this.$route.query.schoolId
      });
      if (code == 200) {
        console.log('获取当前学校的信息', data);
        this.approveId = data.approveId;
        this.schoolName = data.name;
        //  获取公众号列表
        // this.getWxConfigList();
      }
    },
    // 点击跳转至公众号关注页面
    
    guanzhu() {

      // 汉峪小学地址
      window.location.href = "https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzkwMTU1MzA4NA==&scene=110#wechat_redirect"// 汉峪小学
      // 丰奥地址
      // window.location.href = "https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=Mzk0NDIxNjI0Mg==&scene=110#wechat_redirect"
    
    
    },


    // 删除已选中的健康码相关图片
    delImage(str, index) {
      this[str].splice(index, 1);
    },

    cpConfirm(e) {
      this.showCSx = false;
      console.log(e);
      this.carSx = e[0].name;
    },
    cpCancel() {
      this.showCSx = false;
    },
    //触发选择车牌弹窗
    showCpPopup() {
      this.showCSx = true;
    },
    test() {
      console.log('this.$refs.update', this.$refs.update)
      this.$refs.update.beforeRead
    },
    previewImg(imgurl) {
      ImagePreview({
        images: [imgurl],
        closeOnPopstate: true,
      });
    },
    async getSubDetail(id) {
      const { data, code } = await this.$https.getVisitorDetail({
        visitorId: id,
      });
      if (code !== 200) {
        this.$toast("获取详情失败");
        return false;
      }
      this.singleQuery = data;
      if (this.$route.query.type !== "again") {
        this.singleQuery.visitorBeginTime = getDateYMD(data.visitorBeginTime);
        this.singleQuery.visitorEndTime = getDateYMD(data.visitorEndTime);
      } else {
        this.singleQuery.visitorBeginTime = "";
        this.singleQuery.visitorEndTime = "";
      }
      this.personList = [];
      this.personList.push({
        visitorName: data.initiatorName,
        visitorPhone: data.visitorPhone,
        visitorIdCrde: data.visitorIdCrde,
        photoImg: data.photoImg,
      });
      this.curFileList.push({
        url: data.photoImg,
      });
      this.getPersonList(data.id);
      // console.log(data)
    },


    // 访客图片上传
    async avatarUpload() {
      try {
        const imgUrl = await uploadImg2();
        this.personList[0].photoImg = imgUrl;
      } catch (error) {
        this.personList[0].photoImg = "";
      }
    },



    async avatarUpload2(file) {
      try {
        const imgUrl = await uploadImg2(file.file);
          this.$set(this.paramsList,'photoImg',imgUrl);
      } catch (error) {
        // this.personList[0].photoImg = ''
        this.paramsList.photoImg = "";
      }
    },




    // 添加健康码相关图片
    async avatarUpload3() {
      try {
        const imgUrl = await uploadImg();
        // this.personList[0].photoImg = imgUrl
        this.healthcodeImage.push({ type: 0, imgUrl });
      } catch (error) {
        console.log("选中照片失败", error);
      }
    },
    async avatarUpload4() {
      try {
        const imgUrl = await uploadImg();
        // this.personList[0].photoImg = imgUrl
        this.tripCodeImage.push({ type: 1, imgUrl: imgUrl });
      } catch (error) {
        console.log("选中照片失败", error);
      }
    },
    async avatarUpload5() {
      try {
        const imgUrl = await uploadImg();
        this.testProveImage.push({ type: 2, imgUrl });
      } catch (error) {
        console.log("选中照片失败", error);
      }
    },
    // async getWXConfig() {
    //   await this.$https.getWXConfig({
    //     schoolId: this.$store.state.schoolId,
    //   })
    // },
    // 获取同行人员
    async getPersonList(id) {
      const { data, code } = await this.$https.getPersonList({
        visitorId: id,
      });
      if (code !== 200) {
        this.$toast("获取人员失败");
        return false;
      }
      data.forEach((item) => {
        this.personList.push(item);
      });
    },
    async getSysSchool() {
      const { data, code, msg } = await this.$https.getSysSchool({
        // dictType: 'school_function_param',
        schoolId: sessionStorage.getItem("qrcodeSchoolId"),
        // schoolId:"1070770900580810752"
      });
      if (code !== 200) {
        // this.$toast('')
        return;
      }
      // 身份证必填判断
      this.senseIDStatus = data.some((item) => item.functionDictCode == 6);
      // 核酸模块是否必填
      this.nucleStatus = data.some((item) => item.functionDictCode == 29);
      console.log("this.senseIDStatus", this.senseIDStatus, this.nucleStatus);
    },
    clickBack() {
      this.$router.go(-1);
    },

    clickTime(type) {
      this.$refs[type].showTimePopup = true;
    },

    clickSave() {
      // this.$router.push('/transientSave')
      this.transienceSaveData();
    },
    // 暂存
    async transienceSaveData() {
      const { visitorBeginTime, visitorEndTime, ...rest } = this.singleQuery;
      const { code, data } = await this.$https.transienceSave({
        ...rest,
        personnelMessageString: this.personList,
        visitorBeginTime: timeFormart(visitorBeginTime),
        visitorEndTime: timeFormart(visitorEndTime),
        auditId: this.singleQuery.acceptId,
        appointmentType: 0,
        initiatorId: JSON.parse(localStorage.getItem("userInfo")).loginId,
        initiatorName: this.personList[0].visitorName,
        initiatorPhone: this.personList[0].visitorPhone,
        schoolId: JSON.parse(localStorage.getItem("userInfo")).loginSchoolId,
      });
      if (code !== 200) {
        this.$toast("暂存失败，请重试");
        return;
      }
      this.qrcodeUrl = data;
      this.$refs.shareQRcode.showPopup = true;
    },
    handleSelIntervieweeItem(item) {
      // 更新被访人id
      this.$set(this.singleQuery, "acceptId", item.id);
      this.$set(this.singleQuery, "acceptName", item.name);
      this.$refs.interviewee.showiIntervieweePopup = false;
    },

    handleTimeStartConfirm(value) {
      console.log(value, "value");
      this.$set(this.singleQuery, "visitorBeginTime", value);
      this.endMinDate = new Date(value.replace(/-/g, "/"));
      this.$refs.starttime.showTimePopup = false;
    },

    handleTimeEndConfirm(value) {
      this.$set(this.singleQuery, "visitorEndTime", value);
      this.$refs.endtime.showTimePopup = false;
    },

    async afterReadPerson(file) {
      try {
        const imgUrl = await upload(file.file);
        this.paramsList.photoImg = imgUrl;
      } catch (error) {
        this.paramsList.photoImg = "";
        this.addPersonFileList = [];
      }
    },

    beforeDelPerson(item, obj) {
      this.addPersonFileList.splice(obj.index, 1);
    },

    async afterReadCur(file) {
      try {
        const imgUrl = await uploadImg2(file.file);
        this.personList[0].photoImg = imgUrl
        console.log('this.personList[0].photoImg', this.personList[0].photoImg)
      } catch (error) {
        this.personList[0].photoImg = "";
      }


      // const res = await compressAccurately(file.file, 200)
      // console.log('res',res)
      // let fileObj = new File([res], file.name, {
      //   type: res.type,
      // })
      // let formData = new FormData()
      // formData.append('file', fileObj)
      // const { code, data, msg } = await this.$https.upload(formData)
      // // if (code !== 200) {
      // //   this.$toast(msg)
      // //   return false
      // // }
      // // const { realm, address } = data

      // console.log('code, data, msg',code, data, msg)



    },
    beforeDelCur(item, obj) {
      console.log(obj);
      this.curFileList.splice(obj.index, 1);
      this.personList[0].photoImg = "";
    },
    handleAddPerson() {
      if (!this.paramsList.photoImg) {
        this.$toast("请选择识别头像");
        return false;
      }
      if (!this.paramsList.visitorName) {
        this.$toast("请输入姓名");
        return false;
      }
      if (!this.paramsList.visitorPhone) {
        this.$toast("请输入手机号");
        return false;
      }
      if (!validate.isPhone(this.paramsList.visitorPhone)) {
        this.$toast("手机号有误");
        return false;
      }
      if (this.senseIDStatus) {
        if (!this.paramsList.visitorIdCrde) {
          this.$toast("身份证号为空");
          return false;
        }
      }
      if (this.paramsList.visitorIdCrde) {
        if (!validate.isIdCard(this.paramsList.visitorIdCrde)) {
          this.$toast("身份证号有误，请检查");
          return false;
        }
      }
      this.personList.push(this.paramsList);
      this.addPersonFileList = [];
      this.showPersonPopup = false;
      this.paramsList = {};
    },
    changeRadioType(name) {
      console.log("我是总内容的值");
      console.log(this.singleQuery);
      console.log(name);
      // this.radioType = name
      this.singleQuery.visitorGoal = name;
    },

    clickPersonMinus(index) {
      this.personList.splice(index + 1, 1);
    },
    clickSubmit() {
      console.log(this.personList);
      // 测试使用，不测试恢复if的判断
      if (this.validateForm()) {
        this.singleAppointment();
      }
    },
    validateForm() {
      let errMsg = {
        visitorName: "姓名为空",
        visitorPhone: "手机号为空",
        photoImg: "请上传识别头像",
        visitorBeginTime: "请选择开始时间",
        visitorEndTime: "请选择离开时间",
        acceptId: "请选择被访人",
      };
      let obj = this.personList[0];
      let objOther = this.singleQuery;

      if (!obj.visitorName) {
        this.$toast(errMsg.visitorName);
        return false;
      }
      if (!obj.visitorPhone) {
        this.$toast(errMsg.visitorPhone);
        return false;
      }
      if (!validate.isPhone(obj.visitorPhone)) {
        this.$toast("手机号有误");
        return false;
      }
      if (!obj.photoImg) {
        this.$toast(errMsg.photoImg);
        return false;
      }
      if (!objOther.visitorBeginTime) {
        this.$toast(errMsg.visitorBeginTime);
        return false;
      }
      if (!objOther.visitorEndTime) {
        this.$toast(errMsg.visitorEndTime);
        return false;
      }
      if (!objOther.acceptId) {
        this.$toast(errMsg.acceptId);
        return false;
      }
      if (this.senseIDStatus) {
        if (!obj.visitorIdCrde) {
          this.$toast("身份证号为空");
          return false;
        }
      }
      // 离开时间大于开始时间
      if (
        moment(objOther.visitorEndTime).valueOf() -
        moment(objOther.visitorBeginTime).valueOf() <=
        0
      ) {
        this.$toast("离开时间不能小于拜访时间");
        return false;
      }
      if (obj.visitorIdCrde) {
        if (!validate.isIdCard(obj.visitorIdCrde)) {
          this.$toast("身份证号有误，请检查");
          return false;
        }
      }
      if (objOther.carNumber) {
        if (!validate.isLicencePlate(objOther.carNumber)) {
          this.$toast("车牌号有误，请检查");
          return false;
        }
      }

      return true;
    },

    async getWork() {
      const { code, data } = await this.$https.getwork({
        dictType: "visit_reason",
      });
      if (code !== 200) {
        this.$toast("获取预约事由失败");
        return;
      }

      this.work = data;
    },

    // async getMaxDur() {
    //   await this.$https.getMaxDuration({
    //     schoolId: '1049061538447069184',
    //   })
    // },
    //选择拜访事由
    selectType(val) {
      this.singleQuery.visitorGoal = val;
    },
    async singleAppointment() {
      try {
        this.subDisabled = true;
        this.subTextBtn = "预约中...";
        const { visitorBeginTime, visitorEndTime, ...rest } = this.singleQuery;
        console.log("无名值：");
        console.log({ ...rest });

        console.log("我是传递的personMessage的参数");
        console.log(this.personList);
        /*** end ***/
        // 判断核酸板块的传入图片
        if (this.isHealthcode && this.healthcodeImage.length == 0) {
          // 提示添加健康码
          this.$toast({
            // type: "fail",
            message: "添加健康码图片",
          });
          return;
        }
        if (this.isTripCode && this.tripCodeImage.length == 0) {
          // 提示添加健康码
          this.$toast({
            // type: "fail",
            message: "添加行程码图片",
          });
          return;
        }
        if (this.isTestProve && this.testProveImage.length == 0) {
          // 提示添加健康码
          this.$toast({
            // type: "fail",
            message: "添加核酸检测证明图片",
          });
          return;
        }
        const { code, data, msg } = await this.$https.singleAppointment({
          ...rest,
          personnelMessageString: this.personList,
          visitorBeginTime: timeFormart(visitorBeginTime),
          visitorEndTime: timeFormart(visitorEndTime),
          auditId: this.singleQuery.acceptId,
          appointmentType: 0,
          initiatorId: JSON.parse(localStorage.getItem("userInfo")).loginId,
          initiatorName: this.personList[0].visitorName,
          initiatorPhone: this.personList[0].visitorPhone,
          // 核酸相关图片
          visitorHealthCertificate: [
            ...this.healthcodeImage,
            ...this.tripCodeImage,
            ...this.testProveImage,
          ],
          // schoolId:
          //   Object.keys(this.$store.state.inviteSubData).length > 0
          //     ? this.$store.state.inviteSubData.schoolId
          //     : this.$store.state.schoolId,
          schoolId: this.$route.query.schoolId
            ? this.$route.query.schoolId
            : JSON.parse(localStorage.getItem("userInfo")).schoolId,
          openId: JSON.parse(localStorage.getItem("userInfo")).openId,
        });
        if (code !== 200) {
          console.log("错误了");
          this.$toast({
            type: "fail",
            message: msg,
          });
          this.subDisabled = false;
          this.subTextBtn = "确认预约";

          return false;
        }
        // 存本地
        let sub = {
          ...this.personList[0],
          ...this.singleQuery,
        };
        localStorage.setItem("__sub__", JSON.stringify(sub));
        // localStorage.setItem('userInfo', JSON.stringify(data))

        // this.$refs.subsuccess.showPopup = true
        this.$toast({
          type: "success",
          overlay: true,
          message: "预约成功",
          duration: 1500,
          onClose: () => {
            this.$router.push("/visited-history");
          },
        });
        // this.subDisabled = false
        // this.subTextBtn = '确认预约'
      } catch (error) {
        console.log(error);
        this.$toast({
          type: "fail",
          message: "预约失败，请重试！",
        });
        this.subDisabled = false;
        this.subTextBtn = "确认预约";
      } finally {
        this.subDisabled = false;
        this.subTextBtn = "确认预约";
      }
    },
  },
};
</script>
<style lang="scss">
.headIconts {
  height: 100px;
  padding: 10px 10px;
  width: 150px;

  .zt {
    font-size: 12px;
  }
}

.van-field__body {
  input {
    text-align: left;
  }
}

.van-field__label {
  color: #1a1a1a;
  width: 8rem !important;
}

.uploader {
  .van-field__label {
    width: 13rem !important;
  }
}
</style>
<style lang="scss" scoped>
::v-deep .van-uploader__preview-image {
  border-radius: 50%;
  width: 2.75rem;
  height: 2.75rem;
}

::v-deep .van-uploader__preview {
  margin: 0;
}

::v-deep .van-uploader__input-wrapper {
  width: 2.75rem;
  height: 2.75rem;
}

.desc {
  color: #c4c4c4;
  font-size: 10px;
}

question-o {
  font-size: 10px;
}

.outBox {
  padding: 0.5rem 1rem;

  .bjImg {
    width: 100%;
    height: 76px;
    background: blueviolet;
    background: url("./../../assets/photoSubscribe.png") no-repeat 100% 100%;
    background-size: 100% 100%;
    border-radius: 0.75rem;
    padding: 1rem;

    .title {
      font-size: 18px;
      color: #ffffff;
    }

    .welcome {
      margin-top: 4px;
      color: rgba(255, 255, 255, 0.5);
      font-size: 12px;
    }
  }
}

.form-wrap {
  margin: 0 1rem 1rem 1rem;
  box-shadow: 0 0.25rem 1rem rgba(69, 91, 99, 0.1);
  border-radius: 0.75rem;
  overflow: hidden;

  .syList {
    width: 100%;

    .syTag.ed {
      border: 1px solid #3497fd;
      color: #3497fd;
    }

    .syTag {
      width: 39px;
      height: 25px;
      border-radius: 4px;
      border: 1px solid #c7c7c7;
      color: #c7c7c7;
      font-size: 13px;
      font-weight: 400;
      line-height: 25px;
      text-align: center;
      margin-right: 10px;
    }
  }
}

// 健康码,行程码,核酸检测证明
.test_prove {
  margin: 1rem 1rem 0;
  background-color: #fff;
  border-radius: 0.75rem;
  padding: 0 1rem;
  box-shadow: 0 0.25rem 1rem rgba(69, 91, 99, 0.1);

  .test_prove_item {
    .label_item {
      padding: 0.5rem 0;
      display: flex;
      align-items: center;
      line-height: 100%;
      color: #1a1a1a;
      font-size: 1rem;

      .test_prove_item_label {
        margin-right: 0.75rem;
      }
    }

    .img_item {
      display: flex;
      flex-wrap: wrap;

      .image_list {
        position: relative;
        width: 5rem;
        height: 5rem;
        margin: 0 0.5rem 0.5rem 0;

        .image_list_icon {
          position: absolute;
          top: 0.1rem;
          border-radius: 50%;
          right: 0.1rem;
          color: #fff;
          background-color: #000;
        }

        img {
          width: 100%;
          height: 100%;
        }
      }

      .add_img {
        width: 5rem;
        height: 5rem;
        margin-bottom: 0.5rem;
        font-size: 0.75rem;
        line-height: 5rem;
        text-align: center;
        color: #3497fd;
        border-radius: 0.3rem;
        border: 1px dashed #c4c4c4;
      }
    }
  }
}

.add-person-wrap {
  background: #fff;
  box-shadow: 0 0.25rem 1rem rgba(69, 91, 99, 0.1);
  height: 3.375rem;
  text-align: center;
  line-height: 3.375rem;
  margin: 1rem 1rem 0;
  border-radius: 0.75rem;
  font-size: 0.875rem;
  color: rgba(52, 151, 253, 1);

  .iconfont {
    font-size: 0.75rem;
    margin-right: 0.25rem;
  }
}

.add-person {
  padding: 15px 20px;

  .add-person-title {
    text-align: center;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .add-btn-group {
    margin-top: 20px;
  }
}
.popup_tip {
  width: 19.5625rem;
  height: 12.9375rem;
  background-color: #fff;
  border-radius: 1.1875rem;
  padding: 2.125rem 1.5625rem 1.25rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  h6 {
    text-align: center;
    font-size: 1rem;
    font-family: Source Han Sans CN-Medium, Source Han Sans CN;
    font-weight: 500;
    color: #000000;
  }

  .tip_con {
    margin-top: 1.125rem;

    .title {
      // text-indent: 2em;
      font-size: .875rem;
      color: #333333;

      line-height: 1.5625rem;
    }

    .p_text {
      text-indent: 2em;
      font-size: .875rem;
      color: #333333;

      line-height: 1.5625rem;
    }
  }

  .btns {
    display: flex;
    justify-content: space-between;

    .tip_btn {
      height: 2.525rem;
      color: #fff;
      width: 49%;
      text-align: center;
      line-height: 2.525rem;
      background: #3B7CFF;
      border-radius: 1.5625rem;
    }
  }

}
.person-list {
  margin: 1rem 1rem 0;
  box-shadow: 0 0.25rem 1rem rgba(69, 91, 99, 0.1);
  background: #ffffff;
  border-radius: 0.75rem;

  .person-header {
    display: flex;
    justify-content: space-between;
    padding: 1rem 1.25rem;

    >span {
      color: rgba(120, 132, 158, 1);
      font-size: 0.75rem;
    }

    >div {
      .iconfont {
        font-size: 0.75rem;
      }

      font-size: 0.875rem;
      color: rgba(52, 151, 253, 1);
    }
  }

  .person-item {
    padding: 1rem 0;
    margin: 0 1rem;
    border-bottom: 1px solid rgba(244, 244, 246, 0.99);
    margin-bottom: 0.6rem;

    .person-name {
      color: rgba(69, 79, 99, 1);
      font-size: 1rem;
      font-weight: 400;
      margin-bottom: 0.125rem;
    }

    .person-phone {
      color: rgba(120, 132, 158, 1);
      font-size: 0.875rem;
    }

    .person-avatar {
      margin-right: 1rem;

      img {
        width: 3rem;
        height: 3rem;
        border-radius: 0.75rem;
        margin: 0 auto;
        display: block;
        object-fit: cover;
      }
    }

    .handle {
      background: rgba(233, 235, 239, 1);
      border-radius: 0.5rem;
      font-size: 0.6875rem;
      width: 5rem;
      height: 2rem;
      text-align: center;
      line-height: 2rem;
      color: rgba(120, 132, 158, 1);
    }
  }
}
.xieyi-top {
  color: #333;
  font-size: 1rem;
  margin-bottom: 1.2rem;
  font-weight: 700;

  text-align: center;
}
.xieyi-content {
  font-size: 0.73rem;
  max-height: 24rem;
  overflow: auto;
  
  h5,h6{
    color: #333;
    font-weight: 700;
  }
  h5,h6,p {
    
    line-height: 1.5rem;
  }
  p {
    color:#666;
    text-indent: 2em;
  }
}
.xieyi-bottom {
  display: flex;
  justify-content: space-around;
  margin-top: 1.5rem;
}
</style>
